export const createFilterCallback = input => {
	return input.length >= 2;
}

export const createCallback = (input) => {
	return {
		id: input.toLowerCase(),
		name: input
	}
}

function getImage(image, escape, name) {
	const iconClass = "rounded-circle w-30px h-30px flex-shrink-0 of-cover";
	if (image) {
		return `<img class="${iconClass}" width="30" height="30" src="${escape(image)}" loading="lazy" alt="${escape(name)}" />`;
	} else {
		return `<div class="${iconClass} bg-dark text-gray-light d-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-card-image" viewBox="0 0 16 16"><path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/> <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z"/></svg></div>`
	}
}

export const renderCallback = (data, escape) => {
	return (
		`<div class="d-flex align-items-center p-5px">
		    ${getImage(data.image, escape, data.name)}
		    <span class="d-block ms-5px fs-sm">${escape(data.name)}</span>
		</div>`
	)
};

export const renderArtist = {
	option: renderCallback,
	item: renderCallback,
	no_results: (data, escape) => {
		return '<div class="no-results">Nenašli sa žiadne výsledky pre "'+escape(data.input)+'"</div>';
	}
}

export const renderBasic = {
	option: function (item) {
		return (
			`<div class="d-flex align-items-center p-5px">
		    	<span class="d-block ms-5px">${item.name}</span>
			</div>`
		)
	},
	item: function (item) {
		return (
			`<div class="d-flex align-items-center p-5px">
		    	<span class="d-block ms-5px">${item.name}</span>
			</div>`
		)
	},
	no_results: (data, escape) => {
		return '<div class="no-results">Nenašli sa žiadne výsledky pre "'+escape(data.input)+'"</div>';
	}
}

export const configCreate = {
	valueField: 'id',
	labelField: 'name',
	searchField: 'name',
	addPrecedence: 'Pridaj',
	selectOnTab: true,
	createOnBlur: true,
	persist: true,
	render: renderArtist,
	create: createCallback,
	createFilter: createFilterCallback,
	plugins: {
		'clear_button':{
			'title':'Odstráň všetky možnosti',
		}
	},
}

export const config = {
	valueField: 'id',
	labelField: 'name',
	searchField: 'name',
	selectOnTab: true,
	persist: true,
	render: renderArtist,
	plugins: {
		'clear_button':{
			'title':'Odstráň všetky možnosti',
		}
	},
}



const basicConfig = {
	valueField: 'id',
	labelField: 'name',
	searchField: 'name',
	selectOnTab: true,
	persist: true,
	plugins: {
		'clear_button':{
			'title':'Odstráň všetky možnosti',
		}
	},
}

export const artistConfig = {
	...basicConfig, ...{
		render: renderArtist,
	}
}


export const tagConfig = {
	...basicConfig, ...{
		render: renderBasic,
	}
}
